// COPIA da TMA#718 di CriGio @ 8e60f982: src/components/burraco/TabelloneOrizzontale.tsx — CAMBI: la misura del palco e una prop (nell'originale 844 x 390 scritti nel calcolo); I-807 (tma-orc-9): il tasto
// «torna in piedi» non sta piu qui, appiccicato al bordo (sotto la tacca e i tasti di Telegram), ma nella testata del palco (`CpTastoVerticale`), e il margine che gli faceva posto (`pl-12`) e un margine
// SICURO: lascia la tacca e i tasti di Telegram, dal lato giusto per il verso del palco.
import { createPortal } from 'react-dom';

/**
 * IL TABELLONE ORIZZONTALE a schermo intero, aperto da un PULSANTE (non dalla rotazione del telefono, che puo essere bloccata e in una WebView a volte
 * arriva girata). Se il telefono e in piedi, il palco si disegna GIRATO di 90°: si gira il telefono e lo si legge dritto. Se il telefono e gia per traverso,
 * il palco sta dritto. Sta nel `body` (portale) sopra la barra delle schede (livello 40) e SOTTO i fogli (`Sheet`, livello 50), che restano raggiungibili.
 * Il palco dentro (`PalcoScalato`) scala sulla larghezza che ha: qui la larghezza e limitata anche dall'altezza, perche il palco e 844 x 390.
 * Il tasto per tornare in verticale NON e di questo componente: sta nella testata del palco (I-807). Qui restano i margini sicuri: il tabellone copre TUTTO lo schermo, e il bordo
 * che il sistema o Telegram si riprendono (la tacca, i tasti di Telegram a schermo intero) e quello da cui il palco si scosta. Girato (telefono in piedi) il lato sinistro del palco
 * e il bordo ALTO dello schermo e il destro quello BASSO; dritto (telefono per traverso) sono i bordi sinistro e destro.
 * `avvisi` sono le righe di stato della pagina (riconnessione, «non so se e passata», in volo, segnale scartato, tavolo finito): il tabellone e sopra a tutto,
 * quindi le porta DENTRO, in alto e sopra il palco, nel suo stesso verso. Senza, chi gioca in orizzontale non vedrebbe che la rete e caduta. Il riquadro
 * riceve i tocchi e sta sopra il palco: ci vanno SOLO righe brevi (mai un pannello come `ManoFinita`), e senza righe (`avvisi` nullo) non si disegna.
 */
export function TabelloneOrizzontale({
  ruota,
  avvisi,
  palcoLarghezza = 844,
  palcoAltezza = 390,
  children,
}: {
  ruota: boolean;
  avvisi?: React.ReactNode;
  /** la misura del palco che sta dentro (nell'originale 844 x 390 era scritto nel calcolo) */
  palcoLarghezza?: number;
  palcoAltezza?: number;
  children: React.ReactNode;
}) {
  // il lato lungo e il lato corto dello spazio in cui il palco sta, nel suo verso
  const lungo = ruota ? '100dvh' : '100dvw';
  const corto = ruota ? '100dvw' : '100dvh';
  // i margini sicuri sui due lati lunghi del palco (0 fuori da Telegram, dove le variabili non ci sono; 12 px come minimo, il respiro di prima a destra)
  const alto = 'calc(var(--tg-viewport-safe-area-inset-top, 0px) + var(--tg-viewport-content-safe-area-inset-top, 0px))';
  const basso = 'var(--tg-viewport-safe-area-inset-bottom, 0px)';
  const sinistra = 'max(env(safe-area-inset-left, 0px), var(--tg-viewport-safe-area-inset-left, 0px))';
  const destra = 'max(env(safe-area-inset-right, 0px), var(--tg-viewport-safe-area-inset-right, 0px))';
  const inizio = ruota ? alto : sinistra;
  const fine = ruota ? basso : destra;
  return createPortal(
    <div data-tabellone-orizzontale data-ruota={ruota ? 'true' : 'false'} className="fixed inset-0 z-40 overflow-hidden bg-[#041512]">
      <div
        className="absolute left-1/2 top-1/2 flex items-center justify-center"
        style={{ width: lungo, height: corto, transform: `translate(-50%, -50%)${ruota ? ' rotate(90deg)' : ''}` }}
      >
        <div className="w-full" style={{ maxWidth: `calc((${corto} - 16px) * ${palcoLarghezza} / ${palcoAltezza} + 60px)`, paddingLeft: `max(12px, ${inizio})`, paddingRight: `max(12px, ${fine})` }}>
          {children}
        </div>
        {avvisi && (
          <div data-avvisi-tabellone className="absolute left-1/2 top-2 z-20 flex max-h-[45%] w-[min(560px,70%)] -translate-x-1/2 flex-col gap-1.5 overflow-y-auto">
            {avvisi}
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
}
